module.exports = __webpack_public_path__ + "media/images/athletes/1797-e93ce7c4e1864cdb33400855abd2fa7f.png";